export default __webpack_public_path__ + "static/media/BartSimpson.7e372f06.png";